// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"3633f625","283":"f021780f","480":"c9ba63ee","647":"427d04f2","721":"96a75281","802":"cfc07fe2","818":"8dece33b"}[chunkId] + ".css";
};